import React from 'react';
import { Cookie } from 'lucide-react';
import { useLang } from '../../context/LangContext';
import { useCookieConsent } from '../../hooks/useCookieConsent';
import { ROUTES } from '../../constants';
import Button from './Button';

export default function CookieBanner() {
  const { t } = useLang();
  const { showBanner, accept, decline } = useCookieConsent();

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[2000] p-4 md:p-6">
      <div className="max-w-3xl mx-auto bg-navy-mid border border-white/10 rounded-lg shadow-lg
                      p-5 flex flex-col sm:flex-row items-start sm:items-center gap-4">
        <Cookie size={22} className="text-teal flex-shrink-0 mt-0.5 sm:mt-0" />

        <p className="text-silver text-sm leading-relaxed flex-1">
          {t.cookie.message}{' '}
          <a href={ROUTES.GDPR} className="text-teal underline underline-offset-2 hover:text-teal-light transition-colors">
            {t.cookie.learnMore}
          </a>
        </p>

        <div className="flex items-center gap-2 flex-shrink-0">
          <Button variant="ghost" size="sm" onClick={decline}>
            {t.cookie.decline}
          </Button>
          <Button variant="primary" size="sm" onClick={accept}>
            {t.cookie.accept}
          </Button>
        </div>
      </div>
    </div>
  );
}
